<template>
  <appHeader> </appHeader>
  <!-- banner section -->
  <transition name="fade">
    <section class="w3l-banner-background3">
      <div class="container" style="margin-top: 100rpx">
        <div class="blur-mask"></div>
        <div class="home-action-buttons home-login-btn">
          <div class="id-input-wrap">
            <span class="label-text">ID:</span>
            <input
              type="text"
              name="petId"
              v-model="qrcode"
              class="placeholder-text"
              placeholder="Please enter an 8-digit ID number"
              maxlength="8"
            />
          </div>
          <button class="action-item action-item-phone" @click="doSignUp">
            Sign Up
          </button>
          <button class="action-item action-item-contact" @click="doQueryPet">
            Contact the pet owner
          </button>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import appHeader from "@/components/appHeader.vue";
export default {
  name: "appHome",
  components: {
    appHeader,
  },
};
</script>
<script setup>
import { api } from "@/assets/js/requests.js";
import { onMounted, onUnmounted, ref } from "vue";

const qrcode = ref("");
const id = ref("");

const doSignUp = async () => {
  console.log("doping");
  try {
    const res = await loadCodeAndCheck(false);
    console.log(res);
    if (!res || res == null) {
      return;
    }
    id.value = res.id == null ? "" : res.id;
  } catch (error) {
    console.error("调用失败:", error);
    alert("Request failed!")
    return;
  }
  location.href = "/idtags?petid=" + qrcode.value + "&id=" + id.value;
};

const loadCodeAndCheck = (show) => {
  const code = qrcode.value;
  return api.petTags
    .checkCode(code)
    .then((res) => {
      const codeData = res.data?.data;
      if (!codeData || codeData == null) {
        alert("Invalid ID");
        return null;
      }
      if (show && (codeData.id == null || !codeData.id)) {
        alert("No Pet");
        return null;
      }
      console.log("petId:", code, codeData);
      return codeData;
    })
    .catch((error) => {
      console.error("加载宠物数据失败:", error);
      throw error; // 继续抛出，让调用方处理
    });
};

const doQueryPet = async () => {
  console.log("doping");
  if (!qrcode.value) {
    alert("Please enter an 8-digit ID number");
    return;
  }
  try {
    const res = await loadCodeAndCheck(true);
    console.log(res);
    if (!res || res == null) {
      return;
    }
  } catch (error) {
    console.error("调用失败:", error);
    alert("Request failed!")
    return;
  }
  location.href = "/showpet?petid=" + qrcode.value;
};

onMounted(async () => {});

onUnmounted(() => {});
</script>

<style lang="css" scoped>
/* 可以添加样式 */
.id-text {
  font-size: 20px;
  font-weight: bold;
}
.id-input-wrap {
  display: flex;
  align-items: center;
  width: 300px;
  height: 50px;
  background: #ffffff;
  border-radius: 999px; /* 超大圆角胶囊形态 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); /* 柔和底部阴影 */
  padding: 0 10px;
  gap: 5px;
}

/* 登录按钮 */
.home-action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  margin-top: auto;
  padding: 10px 0;
  font-size: 20px;
  gap: 15px;
  position: fixed;
  right: 160px;
  top: 30%;
  width: 300px;
}

.home-login-btn {
  line-height: 40px;
}

.label-text {
  font-size: 20px;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
  width: 30px;
  flex-shrink: 0;
  text-align: right;
}
.placeholder-text {
  font-size: 16px;
  color: #2d2c2c;
  flex: 1;
  user-select: none;
  border: none;
}

.placeholder-text::placeholder {
  font-size: 14px;
  color: #817c7c;
  user-select: none;
  border: none;
}
.action-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  width: 300px;
  height: 100%;
  margin-bottom: 15rpx;
  border-radius: 60px;
  border: none;
  color: white;
  font-weight: bold;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  font-size: 10rpx;
}
.action-item-phone {
  background: linear-gradient(to bottom, #f03b34 0%, #8e0807 100%);
  /* 主渐变 */
}

.action-item-contact {
  background: linear-gradient(to bottom, #90826b 0%, #6a503b 100%);
}

@media (min-width: 896px) {
  .blur-mask {
    position: absolute;
    top: 0;
    right: 0;
    width: 60%;
    height: auto;
    aspect-ratio: 16/9;
    object-fit: cover;
    object-position: center;
    background-image: url("@/assets/images/blurmask.png");
    background-size: cover;
    background-position: center;
    filter: blur(20px);
    background-color: rgba(208,202,190,0.5);
    background-blend-mode: soft-light;
    mask: linear-gradient(to right, transparent 0%, transparent 30%, rgba(0, 0, 0, 0.9) 80%);
    -webkit-mask: linear-gradient(to right, transparent 0%,transparent 30%,  rgba(0, 0, 0, 0.9) 80%);
    pointer-events: none;
  }
}

@media (max-width: 895px) {
  .w3l-banner {
    position: static;
    height: auto;
  }
  .w3l-banner-background3 {
    background: url("@/assets/images/petsmobg1.png") no-repeat center;
    background-size: cover;
    height: 100svh;
    margin: 0;
  }
  .container{
    display: flex;
    flex-direction: column;
  }
  .blur-mask {
    background-image: url("@/assets/images/petsmobg.png");
    background-size:100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 70svh;
    background-position: center;
    pointer-events: none;
    z-index: 0;
  }

  .home-action-buttons {
    /* 取消大屏的定位 */
    right: auto;
    top: auto;
    /* 设置底部居中 */
    left: 50%;
    /* 距底部留点间距，可根据需要调整 */
    transform: translateX(-50%);
    /* 宽度自适应 */
    max-width: 400px;
    gap: 5px;
    display: flex;
    margin-top:71svh;
  }
  .home-login-btn {
    line-height: 30px;
  }
  .action-item {
    width: 210px;
    font-size: 12px;
  }

  .id-input-wrap {
    height: 40px;
    width: 210px;
  }

  .label-text {
    font-size: 12px;
    width:20px;
  }

  .placeholder-text {
    font-size: 12px;
  }

  .placeholder-text::placeholder {
    font-size: 10px;
  }
}
</style>
